module.exports = __WEBPACK_EXTERNAL_MODULE_138__;


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 138
// module chunks = 0